export const PERSONAL_ID_REGEX = /^\d{6}-\d{5}$|^\d{11}$/;

export const isValidPersonalId = (value: string): boolean =>
  PERSONAL_ID_REGEX.test(value);

export const filterPersonalIdInput = (value: string): string =>
  value.replace(/[^\d-]/g, '');

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value: string): boolean =>
  EMAIL_REGEX.test(value.trim());

export const isValidPhone = (value: string): boolean =>
  value.replace(/\D/g, '').length >= 8;

export const PHONE_NUMBER_REGEX = /^(?:\+?371)?2\d{7}$/;

export const isValidPhoneNumber = (value: string): boolean =>
  PHONE_NUMBER_REGEX.test(value.trim());

export const USERNAME_MIN_LENGTH = 6;
export const USERNAME_MAX_LENGTH = 36;
export const USERNAME_REGEX = /^[a-zA-Z0-9_.,+\-*!@#$%^()=]+$/;

export const isValidUsername = (value: string): boolean =>
  value.length >= USERNAME_MIN_LENGTH &&
  value.length <= USERNAME_MAX_LENGTH &&
  USERNAME_REGEX.test(value);

export const PASSWORD_MIN_LENGTH = 9;
const PASSWORD_SPECIAL_REGEX = /[!@#$%^&*(),.?":{}|<>_+\-/=]/;
const PASSWORD_CASE_NUMBER_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/;
const PASSWORD_LATIN_REGEX = /^[a-zA-Z0-9!@#$%^&*(),.?":{}|<>_+\-/=]*$/;

export interface PasswordCriteria {
  hasMinLength: boolean;
  hasSpecialSymbol: boolean;
  hasCaseAndNumber: boolean;
  isOnlyLatin: boolean;
}

export const getPasswordCriteria = (value: string): PasswordCriteria => ({
  hasMinLength: value.length >= PASSWORD_MIN_LENGTH,
  hasSpecialSymbol: PASSWORD_SPECIAL_REGEX.test(value),
  hasCaseAndNumber: PASSWORD_CASE_NUMBER_REGEX.test(value),
  isOnlyLatin: value.length > 0 && PASSWORD_LATIN_REGEX.test(value),
});

export const isValidPassword = (value: string): boolean => {
  const criteria = getPasswordCriteria(value);

  return (
    criteria.hasMinLength &&
    criteria.hasSpecialSymbol &&
    criteria.hasCaseAndNumber &&
    criteria.isOnlyLatin
  );
};

export const hasValue = (value: string): boolean => value.trim().length > 0;

export const hasAtLeastTwoWords = (value: string): boolean =>
  value.trim().split(/\s+/).filter(Boolean).length >= 2;
